import { Box, Button, Popover, useBreakpoints, VerticalStack, HorizontalGrid, DatePicker } from '@shopify/polaris';
import { CalendarMinor } from '@shopify/polaris-icons';
import { useMemo, useState } from 'react';
import { useTimezone } from '../../../customHooks/useTimezone';
import { todayInTz, parseFilterParam, toYMD } from '../../../helpers/dates';

// Single-date picker. Emite en `onDateChanges` un string "YYYY-MM-DD".
const DateSinglePicker = ({ onDateChanges, defaultDate }) => {
  const { mdDown, lgUp } = useBreakpoints();
  const shouldShowMultiMonth = lgUp;
  const { timezone } = useTimezone();

  const today = useMemo(() => todayInTz(timezone), [timezone]);
  const initial = useMemo(() => parseFilterParam(defaultDate, timezone) ?? today, [defaultDate, timezone, today]);

  const [popoverActive, setPopoverActive] = useState(false);
  const [activeDate, setActiveDate] = useState(initial);
  const [showDate, setShowDate] = useState(initial);

  const handleMonthChange = (month, year) => setShowDate(new Date(year, month));
  const handleCalendarChange = ({ start }) => {
    setActiveDate(start);
    onDateChanges(toYMD(start));
  };

  const buttonValue = activeDate.toLocaleDateString('es-Es');

  return (
    <Popover
      active={popoverActive}
      autofocusTarget="none"
      preferredAlignment="left"
      preferredPosition="below"
      fluidContent
      sectioned={false}
      fullHeight
      activator={
        <Button icon={CalendarMinor} onClick={() => setPopoverActive(!popoverActive)}>
          {buttonValue}
        </Button>
      }
      onClose={() => setPopoverActive(false)}
    >
      <Popover.Pane fixed>
        <HorizontalGrid
          columns={{
            xs: '1fr',
            mdDown: '1fr',
            md: 'max-content max-content',
          }}
          gap={0}
        >
          <Box padding={{ xs: 5 }} maxWidth={mdDown ? '320px' : '516px'}>
            <VerticalStack gap="4">
              <DatePicker
                month={showDate.getMonth()}
                year={showDate.getFullYear()}
                selected={activeDate}
                onMonthChange={handleMonthChange}
                onChange={handleCalendarChange}
                multiMonth={shouldShowMultiMonth}
                weekStartsOn={1}
                disableDatesAfter={today}
              />
            </VerticalStack>
          </Box>
        </HorizontalGrid>
      </Popover.Pane>
    </Popover>
  );
};

export default DateSinglePicker;
